<template>
    <div class="wrapper">

      <new-app-header></new-app-header> <hr>

          <section class="bg-light shadow-sm index-forward">
        
              <div class="login">

                  <form @submit.prevent="send()">

                        <div class="login_wrapper_title">
                            <h3>LOGIN</h3>
                            <span class="text-small">Hello, nice to see you!</span>
                            <div class="login_wrapper_title-block mb-5"></div>
                        </div>

                        <div class="form-group">
                            <label for="name"><b>Username </b> <span class="text-danger"> *</span></label>
                            <input class="form-control" type="text" v-model="username"
                                    placeholder="Enter your username" id="name" required>
                        </div>
                        <div class="form-group">
                            <label for="password"><b>Password </b> <span class="text-danger">*</span></label>
                            <input class="form-control" type="password" v-model="password"
                                    placeholder="Enter Password" required id="password">
                        </div>

                        <div class="form-group">
                                <input type="checkbox" @click="visiblePass()"> Check to show password
                        </div>

                        <div class="form-group mt-4">
                            <button class="btn btn-block btn-outline-primary" type="submit">
                                Login
                            </button>
                        </div>

                         <div class="text-center">
                            <span>Dont have an account?</span>
                            <router-link to="/register" class="login_wrapper_form-registrationLink-button">
                                <span> SIGN UP</span>
                            </router-link>
                        </div>
                       
                    </form>

              </div>
              
              <img class="center" src="../../assets/png/img5.png" />

          

          </section>
      
      <new-app-footer></new-app-footer>

    </div>
</template>
<script>
    import UserServices from "../../services/UserServices";
    import Vue from "vue";
    import NewHeader from '@/components/layout/NewHeader';
    import NewFooter from '@/components/layout/NewFooter';

    export default {
        components: {
            'new-app-header': NewHeader,
            'new-app-footer': NewFooter,
        },
        data(){
            return {
               username: '',
               password: '',
               notValid: false,
               message: ''
            }
        },
        created(){
            if(localStorage.token){
                window.location.href = '/';
            }
        },
        methods:{

            visiblePass(){
                let x = document.getElementById("password");
                if (x.type === "password") {
                    x.type = "text";
                } else {
                    x.type = "password";
                }
            },

            async login(){
                try {
                    const responce = await UserServices.userLogin(this.username, this.password);
                    return responce;
                } catch (e) {
                    return e;
                }
            },
           send(){
               if(this.username !== '' && this.password !== '') {
                   this.login().then((resp)=>{
                    console.log(resp)
                    
                    localStorage.token = resp.data.data.token;
                    localStorage.firstname = resp.data.data.user.first_name;
                    localStorage.profile = resp.data.data.user.profile_pic;
                    Vue.prototype.$http.defaults.headers.common['Authorization'] = resp.data.data.token;
                    window.location.href = '/';
                    
                }).catch(() => {
                     this.$swal.fire("Sorry :", "Credentials was not found","warning");
                });
               }
            
            }
        },
    }
</script>
<style lang="scss" scoped>
    .wrapper {
        width:100%;
        max-width: 1920px;
    }
    .buttonClass {
        width: 359px;
        margin-bottom: 22px;
        @media screen and (max-width: 480px) {
            width: 280px;
        }
        cursor: pointer;
    }
    .inputClass {
        width: 359px;
        @media screen and (max-width: 480px) {
            width: 280px;
            font-size: 8px;
        }

    }
    .center {
        display: flex;
        margin: 0 auto;
        @media screen and (max-width: 480px) {
            display: none;
        }
        width: 100%;
        max-width: 600px;
    }
    .login {
        max-width: 508px;
        height: 620px;
        box-shadow: 0 0 35px rgba(0, 0, 0, 0.15);
        background-color: #ffffff;
        margin: 61px auto 15px;
        padding: 15px;
        z-index: 3;
        &_wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            &_title {
                margin-top: 31px;
                display: flex;
                flex-direction: column;
                align-items: center;
                span {
                    color: #38383a;
                    font-family: "Optimal C";
                    font-size: 30px;
                    @media screen and (max-width: 480px) {
                        font-size: 26px;
                    }
                    font-weight: 400;
                    letter-spacing: 0.07px;
                    &:first-child {
                        color: #adadad;
                        font-family: "Open Sans";
                        font-size: 12px;
                        font-weight: 400;
                        text-transform: uppercase;
                        letter-spacing: 0.3px;
                        margin-bottom: 21px;
                        @media screen and (max-width: 480px) {
                            font-size: 10px;
                            margin-bottom: 11px;
                        }
                    }
                }
                &-block {
                    margin-top: 18px;
                    width: 63px;
                    height: 3px;
                    background-color: #2a9854;
                    margin-bottom: 65px;
                }
            }
            &_form {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                &-invalid {
                    color: red;
                    font-family: "Open Sans";
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0.3px;
                    margin-bottom: 22px;
                }
                &-registrationLink {
                    display: flex;
                    align-items: center;
                    flex-direction: row;
                    span {
                        color: #7a7a7c;
                        font-family: "Open Sans";
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0.3px;
                        margin-right: 5px;
                        @media screen and (max-width: 480px) {
                            font-size: 10px;
                        }
                    }
                    &-button {
                        text-decoration: none;
                        span{
                            color: #1a924a;
                            font-family: "Open Sans - Semi Bold";
                            font-size: 14px;
                            font-weight: 600;
                            letter-spacing: 0.35px;
                            text-transform: uppercase;
                            cursor: pointer;
                            
                        }
                    }
                }
            }
        }
    }
</style>
